import { Accordion, Autocomplete, AccordionDetails, AccordionSummary, Button, Grid, MenuItem, Select, styled, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import TableN from "../../reusableComponents/components/generics/TableN";
import { t } from 'i18next';
import Delete from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { fetchInsureeClaimService } from '../../action';
import { decodeId } from '../../utils/helper';

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  '& .MuiAccordionSummary-content': {
    margin: '0px !important',
  }
}));

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: '.8rem',
}));




export const PreAuthServiceExam = ({ onDataChange, claimData, updateTotalClaimed, updateTMvalue, disabled }) => {

  const SignInSuccess = useSelector((state) => state);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);
  const [totalClaimed, setTotalClaimed] = useState(0);

  const InsureeCode = SignInSuccess?.profileReducer?.insureeByIdResponseData;
  const priceListId = SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees;
  const serviceId = priceListId?.[0]?.servicesPricelist?.id;
  const [totalTmValue, setTotalTmValue] = useState(0);
  const [totalCountedPrice, setTotalCountedPrice] = useState(0);
  const hfId = priceListId?.[0]?.id;
  const insureeId = InsureeCode?.[0]?.id;

  useEffect(() => {
    if (serviceId && hfId && insureeId) {
      dispatch(fetchInsureeClaimService(serviceId, hfId, insureeId));
    }
  }, [dispatch, serviceId, hfId, insureeId]);

  useEffect(() => {
    if (SignInSuccess?.fosaReducer?.ClaimServices) {
      const services = SignInSuccess.fosaReducer.ClaimServices;
      const filtered = services.filter(service => service.categoryType === "T");
      setFilteredServices(filtered);
    }
  }, [SignInSuccess]);

  // Initialize rows with claimData services or one empty row
  useEffect(() => {
    if (claimData?.services && claimData.services.length > 0) {
      const initialRows = claimData.services
        .filter(service => service.service.categoryType === "T")
        .map(service => {
          const jsonExt = JSON.parse(service.jsonExt || '{}');
          return {
            serviceId: decodeId(service.service.id),
            service: service.service.name,
            price: service.service.price,
            quantity: service.qtyProvided,
            priceAsked: service.priceAsked,
            countedPrice: jsonExt.countedPrice,
            tmValue: jsonExt.tmValue,
            explanation: service.explanation,
          };
        });
      setRows(initialRows);
      setSelectedServices(initialRows.map(row => row.service));
      calculateTotalClaimed(initialRows);
      onDataChange(initialRows)
    } else {
      setRows([{ service: '', quantity: '', price: '', tmValue: '', countedPrice: '' }]);
    }
  }, [claimData]);

  const handleServiceChange = (index, event) => {
    const serviceName = event.target.value;
    const selectedService = filteredServices.find(service => service.name === serviceName);
    const jsonExt = JSON.parse(selectedService?.jsonExt || '{}');
    const newRows = rows.map((row, i) =>
      i === index ? {
        ...row,
        serviceId: selectedService?.id,
        service: serviceName,
        price: selectedService?.price,
        quantity: 1,  // Default quantity
        priceAsked: selectedService?.price,
        countedPrice: jsonExt.countedPrice,
        tmValue: jsonExt.tmValue,
      } : row
    );
    setRows(newRows);
    onDataChange(newRows);
    const newSelectedServices = newRows.map(row => row.service).filter(service => service !== '');
    setSelectedServices(newSelectedServices);
    calculateTotalClaimed(newRows);
  };

  const handleChange = (index, event) => {
    const { name, value } = event.target;
    const newRows = rows.map((row, i) =>
      i === index ? { ...row, [name]: value } : row
    );
    setRows(newRows);
    onDataChange(newRows);
    if (name === 'quantity') {
      calculateTotalClaimed(newRows); // Update total claimed amount
    }
  };

  const addRow = () => {
    setRows([...rows, { service: '', quantity: '', price: '', tmValue: '', countedPrice: '' }]);
  };

  const deleteRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
    const newSelectedServices = newRows.map(row => row.service).filter(service => service !== '');
    setSelectedServices(newSelectedServices);
    calculateTotalClaimed(newRows);
    onDataChange(newRows)
  };

  const getAvailableServices = (currentService) => {
    return filteredServices.filter(service => !selectedServices.includes(service.name) || service.name === currentService);
  };

  const headers = () => {
    return [
      t("Service"),
      t("Quantity"),
      t("Price"),
      t("TicketModerateur"),
      t("CountedPrice"),
      t("Action")
    ];
  };

  const calculateTotalClaimed = (rows) => {
    const total = rows.reduce((sum, row) => sum + (row.quantity * row.price), 0);
    const totalTm = rows.reduce((sum, row) => sum + Number(row.tmValue || 0), 0);
    const totalCountedPrice = rows.reduce((sum, row) => sum + Number(row.countedPrice || 0), 0);

    setTotalClaimed(total);
    setTotalTmValue(totalTm);
    setTotalCountedPrice(totalCountedPrice);
    updateTMvalue(totalTm);
    updateTotalClaimed(total);
  };

  const itemFormatters = () => {
    return [
      (row, index) => (
        <div>
          <Autocomplete
            options={getAvailableServices(row.service).map((service) => ({
              label: service.code,
              id: service.name
            }))}
            sx={{ width: 200 }}
            size="small"
            value={row.service ? getAvailableServices(row.service).find(service => service.name === row.service)?.code : null}
            disabled={disabled}
            onChange={(e, option) => {
              console.log("===> option", option)
              handleServiceChange(index, { target: { value: option?.id } });
            }}
            renderInput={(params) => <TextField {...params} />}
          />
          {/* <Select
            value={row?.service}
            onChange={(e) => handleServiceChange(index, e)}
            displayEmpty
            size="small"
          >
            <MenuItem value="">
              <em>{t("Select")}</em>
            </MenuItem>
            {getAvailableServices(row.service).map(service => (
              <MenuItem key={service.id} value={service.name}>{service.code}</MenuItem>
            ))}
          </Select> */}
        </div>
      ),
      (row, index) => (
        <TextField
          className="no-arrow"
          type="number"
          name="quantity"
          size="small"
          value={row?.quantity ? row.quantity : ""}
          onChange={(e) => handleChange(index, e)}
          disabled={disabled}
        />
      ),
      (row, index) => (
        <TextField
          type="text"
          name="price"
          value={row?.price ? row.price : ""}
          size="small"
          disabled={true}
          onChange={(e) => handleChange(row, e, 'price')}
        />
      ),
      (row, index) => (
        <TextField
          type="text"
          name="ticket"
          size="small"
          value={row?.tmValue ? row.tmValue : ""}
          disabled={true}
          onChange={(e) => handleChange(row, e, 'ticket')}
        />
      ),
      (row, index) => (
        <TextField
          type="text"
          name="countedPrice"
          size="small"
          value={row?.countedPrice ? row.countedPrice : ""}
          disabled={true}
          onChange={(e) => handleChange(row, e, 'countedPrice')}
        />
      ),

      (row, index) => (
        disabled ? "" : <Button startIcon={<Delete style={{ color: "red" }} />} onClick={() => deleteRow(index)}></Button>
      )
    ];
  };

  const preHeaders = [
    "\u200b",
    "",
    totalClaimed > 0 ? t("Total Claimed: ") + totalClaimed : "",
    totalTmValue > 0 ? t("Total TM: ") + totalTmValue : "",
    totalCountedPrice > 0 ? t("Total Supported by Camu: ") + totalCountedPrice : "",
    ,
    " ",
    " "
  ];
  return (
    <StyledAccordion>
      <StyledAccordionSummary
        expandIcon={<IndeterminateCheckBoxOutlinedIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography variant="h6">
          {t("ServicesExamination")}
        </Typography>

      </StyledAccordionSummary>
      <AccordionDetails>
        <TableN
          headers={headers()}
          itemFormatters={itemFormatters()}
          preHeaders={preHeaders}
          items={rows}
          withSelection={"single"}
          withPagination={false}
        />
        {disabled ? "" :<Button onClick={addRow}>{t("Add")}</Button>}
      </AccordionDetails>
    </StyledAccordion>
  );
}

